import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { SplashScreenDataSource } from './useSplashScreenDatasources';

export const SplashScreenDatasourceErrorText = ({
    failedImports
}: {
    failedImports: Exclude<SplashScreenDataSource['failedImports'], undefined>;
}) => {
    if (failedImports.length === 1) {
        return (
            <p>
                An error occurred while connecting to the data source.{' '}
                <Link to={`/datasource/${failedImports[0].configId}`} className='text-textLink hover:underline'>
                    Manage data source
                </Link>
            </p>
        );
    }

    return (
        <div>
            <p>An error occurred while connecting to the data sources.</p>
            {failedImports.map((imported) => (
                <p key={imported.configId} className='mt-1'>
                    <FontAwesomeIcon icon={faXmarkCircle} className='mr-2 text-textDestructive' />
                    <span>
                        {imported.displayName}{' '}
                        <Link to={`/datasource/${imported.configId}`} className='text-textLink hover:underline'>
                            Manage data source
                        </Link>
                    </span>
                </p>
            ))}
        </div>
    );
};
